import React from "react";
import { useAuth } from "../../components/context/Auth";
import styles from "./Production.module.css";

const Production = ({ otpActoken, setOtpAcToken }) => {
  const { mode } = useAuth();
  return (
    <div className={`${styles.root} ${mode ? styles.dark : styles.light}`}>
      Production
    </div>
  );
};

export default Production;
